export default __webpack_public_path__ + "static/media/email_verification.18edf136.svg";